import { render, staticRenderFns } from "./HowToWeb3.vue?vue&type=template&id=59c8e3c6&scoped=true&"
import script from "./HowToWeb3.vue?vue&type=script&lang=js&"
export * from "./HowToWeb3.vue?vue&type=script&lang=js&"
import style0 from "./HowToWeb3.vue?vue&type=style&index=0&id=59c8e3c6&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59c8e3c6",
  null
  
)

export default component.exports